import Immutable from 'immutable';
import { RawRFI, RFI, RFIList } from 'records/RFI';

// type ViewRFIsResponse {
//   rfis: [RFI!]!
//   cursor: String!
// }

export interface RawRFIResponse {
  rfis: RawRFI[];
  cursor: string;
}

export interface RFIResponseData {
  rfis: RFIList;
  cursor: string;
}

const defaultValues: RFIResponseData = {
  rfis: Immutable.List(),
  cursor: '',
};

export const RFIResponseFactory = Immutable.Record(
  defaultValues,
  'RFIResponse'
);

export class RFIResponse extends RFIResponseFactory {
  static deserialize(rawRFIResponse: RawRFIResponse): RFIResponse {
    return new RFIResponse({
      rfis: Immutable.List<RFI>(rawRFIResponse.rfis.map(RFI.deserialize)),
      cursor: rawRFIResponse.cursor,
    });
  }

  serialize(): RawRFIResponse {
    return this.toJS();
  }
}
